export const API_ADMIN_PANEL_AGENCY_DOCTORS = 'core/admin-panel/agency-doctors';
export const API_DOCTOR_UPDATE_PROFILE = 'core/doctors/profile';
export const API_AGENCY_DOCTOR_UPDATE_PROFILE = 'core/agency-doctors/profile';
export const API_PATIENT_DOCTOR_MESSAGES = 'core/doctors/messages';
export const apiAdminPanelUser = `core/admin-panel/doctors`;
export const API_DOCTOR_CLINICS = 'core/clinics';
export const API_DOCTOR_INSURANCE_TYPES = 'core/insurances';
